(function(){
  var DELAY = 1100;
  function init(root){
    var imgs = [].slice.call(root.querySelectorAll('.zeep-flip__img'));
    if (imgs.length < 2 || root.__zf) { return; }
    root.__zf = true;
    var dots = [].slice.call(root.querySelectorAll('.zeep-flip__dot'));
    var idx = 0, timer = null;
    function mark(n){ dots.forEach(function(d, i){ d.classList.toggle('is-on', i === n); }); }
    function show(n){
      if (n === idx) { return; }
      imgs[idx].classList.remove('is-active');
      imgs[idx].classList.add('is-prev');
      imgs[n].classList.remove('is-prev');
      imgs[n].classList.add('is-active');
      idx = n; mark(n);
    }
    function start(){
      if (timer) { return; }
      show((idx + 1) % imgs.length);
      timer = setInterval(function(){ show((idx + 1) % imgs.length); }, DELAY);
    }
    function stop(){
      if (timer) { clearInterval(timer); timer = null; }
      imgs.forEach(function(im, i){ im.classList.remove('is-prev'); im.classList.toggle('is-active', i === 0); });
      idx = 0; mark(0);
    }
    var host = root.closest('.zeep-card') || root;
    host.addEventListener('mouseenter', start);
    host.addEventListener('mouseleave', stop);
    host.addEventListener('touchstart', start, { passive: true });
    host.addEventListener('touchend', stop);
    host.addEventListener('touchcancel', stop);
    host.addEventListener('focusin', start);
    host.addEventListener('focusout', stop);
  }
  function run(){ document.querySelectorAll('[data-zeep-flip]').forEach(init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', run); } else { run(); }
})();
